import React, { FC } from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';

import { useTranslation } from '../../i18n';

type AttachmentsDropzoneDescriptionProps = {
  maxNumberOfAttachments?: number;
};

const AttachmentsDropzoneDescription: FC<
  AttachmentsDropzoneDescriptionProps
> = ({ maxNumberOfAttachments }) => {
  const { t } = useTranslation();

  return (
    <Flex
      alignItems="center"
      marginTop="8px"
      textAlign="center"
      color="charcoal700"
      data-testid="AttachmentsDropzoneSmallContent"
      flexDirection="column"
    >
      <Flex justifyContent="center" alignItems="center">
        <Text typography="bodyMedium" whiteSpace="pre-line">
          {t('DROPZONE_DESCRIPTION')}
        </Text>
      </Flex>
      {maxNumberOfAttachments && (
        <Flex justifyContent="center" alignItems="center">
          <Text typography="bodyMediumBold">
            {t('MAX_ATTACHMENTS_ALLOWED', {
              maxNumberOfAttachments,
            })}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};

export default AttachmentsDropzoneDescription;
